import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import Link from 'components/UI/Link/Link';
import AppliedFilter from './AppliedFilter/AppliedFilter';
import CloseIcon from 'components/Common/Icons/Close';
import { getUri } from 'services/generic';
import { AppliedFilterType } from 'types/ProductListing/ProductListing';

import styles from './AppliedFilters.module.scss';

type PropsType = {
  filters: AppliedFilterType[];
  resetUrl: string;
} & HTMLAttributes<HTMLDivElement>;

export default function AppliedFilters({
  filters,
  resetUrl,
  ...props
}: PropsType): JSX.Element {
  const { className, ...rest } = props;
  const { t } = useTranslation('listingPage');

  return (
    <div className={classNames(styles.container, className)} {...rest}>
      <Link to={resetUrl} className={styles.clearFilters}>
        {t('CLEAR_FILTERS')}
        <CloseIcon />
      </Link>
      <div className={styles.listWrapper}>
        <ul>
          {filters.map(({ label, removeUrl }) => (
            <li key={label}>
              <AppliedFilter label={label} removeUrl={getUri(removeUrl)} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
